import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useStateValue } from 'providers'
import { apiFetch } from 'actions/apiFetch'
import { usePostQuery, useGetQuery } from 'hooks'
import { Card, Title } from 'components'
import { EventForm } from './form'

export const EventNew = () => {
  const [{ session: { user } }] = useStateValue()
  const navigate = useNavigate()
  const { state: routerState } = useLocation()

  const isHost = ['host:owner', 'host:manager'].includes(user?.roles?.[0]?.slug)

  const { data: hostData } = useGetQuery({
    enabled: isHost,
    url: '/host/places'
  })
  const hostPlaces = isHost ? (hostData?.locations?.rows ?? null) : []

  const { post: createEvent } = usePostQuery({ url: '/events' })

  const searchPlaces = isHost ? null : (q) => apiFetch({ path: `/locations?q=${encodeURIComponent(q)}` })

  const preselected = routerState?.address_id
    ? { address_id: routerState.address_id, address: routerState.address }
    : {}

  const handleSubmit = async (payload) => {
    const result = await createEvent(payload)
    if (result?.event?.id) navigate(`/events/${result.event.id}`)
  }

  if (isHost && hostPlaces === null) return null

  return (
    <Card>
      <Title level={2}>New Event</Title>
      <EventForm
        initial={preselected}
        onSubmit={handleSubmit}
        submitLabel="Create Event"
        searchPlaces={searchPlaces}
        places={hostPlaces}
      />
    </Card>
  )
}
